<dx-popup
  [(visible)]="visible"
  [showTitle]="true"
  title="Rejeter l'Intervention"
  [dragEnabled]="true"
  [closeOnOutsideClick]="false"
  [width]="800"
  [height]="600"
  (onHiding)="close()">
  
  <div *dxTemplate="let data of 'content'">
    <dx-scroll-view [height]="480">
      <div class="p-4 space-y-4">
        <div>
          <h4 class="font-medium mb-3">Corrections Détaillées (optionnel)</h4>
          <p class="text-sm text-gray-600 mb-4">
            Cochez les champs incorrects et spécifiez les bonnes valeurs pour chaque problème identifié.
          </p>
          
          <div class="grid grid-cols-2 gap-3">
            <div *ngFor="let fc of fieldCorrections" class="border rounded p-3">
              <dx-check-box
                [(value)]="fc.enabled"
                [text]="fc.fieldLabel"
                class="font-medium">
              </dx-check-box>
              
              <div *ngIf="fc.enabled" class="ml-6 mt-2 space-y-2">
                <div>
                  <label class="block text-sm mb-1">Problème Identifié</label>
                  <dx-text-box
                    [(value)]="fc.issue"
                    placeholder="Décrivez le problème">
                  </dx-text-box>
                </div>
                
                <div>
                  <label class="block text-sm mb-1">Valeur Correcte</label>
                  <dx-text-box
                    [(value)]="fc.correctValue"
                    placeholder="Entrez la valeur correcte">
                  </dx-text-box>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div>
          <label class="block mb-2 font-medium">Raison du Rejet (optionnel)</label>
          <dx-text-area
            [(value)]="rejectionReason"
            [height]="80"
            placeholder="Ex: Données GPS de mauvaise qualité, Détection incorrecte, etc. (optionnel)">
          </dx-text-area>
        </div>
      </div>
    </dx-scroll-view>
    
    <div class="p-4 border-t">
      <dx-button
        text="Rejeter"
        type="danger"
        (onClick)="reject()"
        class="mr-2">
      </dx-button>
      <dx-button
        text="Annuler"
        (onClick)="close()">
      </dx-button>
    </div>
  </div>
</dx-popup>

